// Lib imports
import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

// Views
import Login from '../views/Login.vue'
import Test from '../views/Test.vue'
import Overview from '../views/Overview.vue'
import AdminSettings from '../views/AdminSettings.vue'
import Product from '../views/Product.vue'
import EditProduct from '../views/EditProduct.vue'
import AddEditVersion from '../views/AddEditVersion.vue'
import AddPatch from '../views/AddPatch.vue'

Vue.use(Router)

// Create a new router
const router = new Router({
  mode: 'history',
  routes: [
    { path: '/overview', name: 'Overview', component: Overview },
    { path: '/product/:id', name: 'Product', component: Product },
    { path: '/login', name: 'Login', component: Login },
    { path: '/product/:productId/edit-product/', name: 'EditProduct', component: EditProduct},
    { path: '/product/:productId/add-version', name: 'AddVersion', component: AddEditVersion},
    { path: '/product/:productId/add-patch/:versionId', name: "AddPatch", component: AddPatch},
    { path: '/product/:productId/edit-version/:versionId', name: 'EditVersion', component: AddEditVersion},
    { path: '/admin', name: 'Admin',
      component: AdminSettings,
      beforeEnter: (to, from, next) => {
        if (store.getters["user/isUserAdmin"]) {
          next()
        } else {
          next({ name: 'Overview' })
        }
      }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})
export default router
